import React from 'react'
import PropTypes from 'prop-types'
import '../../index.css'

const AnalyseSelect = ({ isActive = false, width, height }) => {
    return (
        <>

            <svg xmlns="http://www.w3.org/2000/svg" width={28} height={28} viewBox="0 0 36 36" fill="none">
                {isActive
                    ? <>
                        <path d="M17.2039 23.3789L17.3453 23.2375L17.2039 23.0961L13.509 19.4012C14.3613 18.2566 14.825 16.8855 14.825 15.4375C14.825 11.752 11.8105 8.7375 8.125 8.7375C4.43954 8.7375 1.425 11.752 1.425 15.4375C1.425 19.123 4.43954 22.1375 8.125 22.1375C9.57295 22.1375 10.9441 21.6738 12.0887 20.8215L15.7836 24.5164L15.925 24.6578L16.0664 24.5164L17.2039 23.3789ZM17.875 9.55H17.675V9.75V11.375V11.575H17.875H24.375H24.575V11.375V9.75V9.55H24.375H17.875ZM11.375 5.4875H11.175V5.6875V7.3125V7.5125H11.375H24.375H24.575V7.3125V5.6875V5.4875H24.375H11.375ZM11.375 1.425H11.175V1.625V3.25V3.45H11.375H24.375H24.575V3.25V1.625V1.425H24.375H11.375ZM8.125 20.1125C5.55421 20.1125 3.45 18.0083 3.45 15.4375C3.45 12.8667 5.55421 10.7625 8.125 10.7625C10.6958 10.7625 12.8 12.8667 12.8 15.4375C12.8 18.0083 10.6958 20.1125 8.125 20.1125Z" fill="white" stroke="white" strokeWidth="0.4"/>
                    </>
                    : <>
                        <path d="M17.0625 23.2375L13.2437 19.4187C14.1375 18.2812 14.625 16.9 14.625 15.4375C14.625 11.8625 11.7 8.9375 8.125 8.9375C4.55 8.9375 1.625 11.8625 1.625 15.4375C1.625 19.0125 4.55 21.9375 8.125 21.9375C9.5875 21.9375 10.9688 21.45 12.1062 20.5562L15.925 24.375L17.0625 23.2375ZM8.125 20.3125C5.44375 20.3125 3.25 18.1187 3.25 15.4375C3.25 12.7563 5.44375 10.5625 8.125 10.5625C10.8062 10.5625 13 12.7563 13 15.4375C13 18.1187 10.8062 20.3125 8.125 20.3125ZM17.875 9.75H24.375V11.375H17.875V9.75ZM11.375 5.6875H24.375V7.3125H11.375V5.6875ZM11.375 1.625H24.375V3.25H11.375V1.625Z" fill="#007876" />
                    </> }
            </svg>
        </>
    )
}

AnalyseSelect.propTypes = {
    isActive: PropTypes.bool,
    width: PropTypes.any,
    height: PropTypes.any
}

export default AnalyseSelect
